export const FETCH_SPECIAL_PRICE_LOG_UPDATES = 'FETCH_SPECIAL_PRICE_LOG_UPDATES';
export const SPECIAL_PRICE_LOG_SET_PAGE_SIZE = 'SPECIAL_PRICE_LOG_SET_PAGE_SIZE';
export const SPECIAL_PRICE_LOG_SET_PAGE_NO = 'SPECIAL_PRICE_LOG_SET_PAGE_NO';
export const CLEAR_SPECIAL_PRICE_LOG = 'CLEAR_SPECIAL_PRICE_LOG';
